const state = {
  searchText: ''
}

const getters = {
  searchText: (state) => {
    return state.searchText
  },
  hasSearchText: (state) => {
    return state.searchText?.length > 0 || false
  }
}

const mutations = {
  setSearchText(state, newValue) {
    state.searchText = newValue
  }
}

const actions = {
  searchForText({commit}, data) {
    commit('setSearchText', data)
  },
  clearSearch({commit}) {
    commit('setSearchText', '')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}